// LIBRARY
import React from "react"
import BarangayTable from './table'

class TownList extends React.Component { 	
	render(){
		return (
			<div>
				<BarangayTable/>
			</div>
		);
	}
}


export default TownList;
  